import { render, staticRenderFns } from "./GeneralFinance.vue?vue&type=template&id=eca4cd6c&"
import script from "./GeneralFinance.vue?vue&type=script&lang=js&"
export * from "./GeneralFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports